import React from 'react';

// DEPENDENCIES
import isError from 'lodash/isError';
import startCase from 'lodash/startCase';

// HELPERS/HOOKS
import { getLogData } from '../helpers/getLogData';
import { useLogContext } from '../helpers/logContext';

// LOCAL PARTS
import LogPill from '../parts/LogPill';
import LogTab from '../parts/LogTab';

// STYLES
import styles from '../logs.module.scss';

// MAIN COMPONENT
const Log = getLogData(({
  children,
  name,
  title = startCase(name),
  tools,
  item: Item = () => null,
  before,
  after,
  errorMessage = `Unable to load ${title.toLowerCase()}.`,
  emptyMessage = `No ${title.toLowerCase()}.`,
}) => {

  // HOOKS
  const { activeLog, logs: { [name]: { data } = {} } } = useLogContext();

  // RENDER
  return activeLog !== name ? null : (<>
    <div className={styles.header}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.tools}>{tools}</div>
    </div>
    <div className={styles.body}>
      {!!before &&
        <p className={styles.before}>{before}</p>
      }
      {children}
      {!data ? null : isError(data) ? (
        <p className="text-danger">{errorMessage}</p>
      ) : !data.length ? (
        <p>{emptyMessage}</p>
      ) : data.map((item = {}, i) => (
        <Item key={i} index={i} {...item} />
      ))}
      {!!after &&
        <p className={styles.after}>{after}</p>
      }
    </div>
  </>)
});

// EXPORT
Log.Tab = LogTab;
Log.Pill = LogPill;
export default Log;
